import { FileDown } from "lucide-react";
import { SITE } from "@/constants/testIds";

/** Cover image + PDF viewer/download button, or a "coming soon" placeholder. */
export function ReportPdfSection({ report, pdf, cover }) {
  return (
    <>
      {cover && (
        <img
          src={cover}
          alt=""
          className="w-full rounded-xl border border-kira-border mb-6 object-cover max-h-[420px]"
        />
      )}

      {pdf ? (
        <div className="mb-8">
          <div className="flex items-center justify-between mb-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-kira-gold">Full Report</p>
            <a
              data-testid={SITE.reportDownloadBtn}
              href={pdf}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-md bg-kira-gold px-4 py-2 text-sm font-semibold text-black hover:bg-kira-goldHover transition-colors"
            >
              <FileDown className="h-4 w-4" /> Download PDF
            </a>
          </div>
          <iframe
            data-testid={SITE.reportPdfFrame}
            src={pdf}
            title={`${report.company_name} — KIRA Report`}
            className="w-full h-[720px] rounded-xl border border-kira-border bg-white"
          />
        </div>
      ) : (
        <div className="rounded-xl border border-dashed border-kira-border py-10 text-center mb-8">
          <p className="text-sm text-kira-textMuted">The full PDF report will be attached shortly.</p>
        </div>
      )}
    </>
  );
}
